import React from "react";
import { useSelector } from "react-redux";
import "./OverlayStyles.css";

export default function Loading() {
  const visible = useSelector(
    state => state.dialog.loading || state.onboarding.isLoading
  );

  if (!visible) return null;

  return (
    <div className="loading-overlay">
      <div className="loader"></div>
    </div>
  );
}